import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9970c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "card py-5 px-5 mb-3" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body py-4" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_8 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = {
  key: 0,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_14 = {
  key: 1,
  class: "detail-grid"
}
const _hoisted_15 = { class: "detail-row" }
const _hoisted_16 = { class: "detail-label" }
const _hoisted_17 = { class: "detail-value" }
const _hoisted_18 = { class: "detail-row" }
const _hoisted_19 = { class: "detail-label" }
const _hoisted_20 = { class: "detail-value" }
const _hoisted_21 = { class: "detail-row" }
const _hoisted_22 = { class: "detail-label" }
const _hoisted_23 = { class: "detail-value" }
const _hoisted_24 = { class: "detail-row" }
const _hoisted_25 = { class: "detail-label" }
const _hoisted_26 = { class: "detail-value" }
const _hoisted_27 = { class: "detail-row" }
const _hoisted_28 = { class: "detail-label" }
const _hoisted_29 = { class: "detail-value" }
const _hoisted_30 = { class: "detail-row" }
const _hoisted_31 = { class: "detail-label" }
const _hoisted_32 = { class: "detail-value" }
const _hoisted_33 = { class: "detail-row" }
const _hoisted_34 = { class: "detail-label" }
const _hoisted_35 = { class: "detail-value" }
const _hoisted_36 = {
  key: 2,
  class: "text-center text-gray-500 py-10"
}

import { ref, computed, onMounted, provide } from "vue";
import { useI18n } from "vue-i18n";
import moment from "moment";
import Decimal from "decimal.js";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import svc from "../services/PaymentService";
import {
  PaymentReceivableTransactionStatusTypes,
  PaymentReceivableTypes,
} from "@/core/types/PaymentTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReceivingRecordIndex',
  setup(__props) {

const { t } = useI18n();

const isLoading = ref(false);
provide("isLoading", isLoading);

const data = ref<any[]>([]);
const criteria = ref<any>({
  page: 1,
  size: 10,
});

// 工具栏筛选：默认全部（null 表示全部，不传给接口）
const filters = ref<{ type: string | null; status: number | null }>({
  type: null,
  status: null,
});

// type 选项取自枚举的字符串 key（传给接口的也是这个 string）
const typeOptions = Object.keys(PaymentReceivableTypes).filter((k) =>
  isNaN(Number(k))
);

const HIDDEN_COLUMNS = ["id"];
const columns = computed<string[]>(() =>
  data.value.length > 0
    ? Object.keys(data.value[0]).filter((k) => !HIDDEN_COLUMNS.includes(k))
    : []
);

// 列表头的多语言映射（未列出的列保留原始字段名）
const COLUMN_LABELS: Record<string, string> = {
  type: "fields.type",
  status: "fields.status",
  amount: "fields.amount",
  accountNumber: "fields.accountNumber",
  assignedPartyId: "fields.partyId",
  assignedAccountId: "fields.accountId",
  assignedOn: "fields.assignedOn",
  createdOn: "fields.createdOn",
  updatedOn: "fields.updatedOn",
  data: "fields.data",
  lookupKey: "fields.lookupKey",
  referenceNumber: "fields.referenceNumber",
};
const columnLabel = (col: string) =>
  COLUMN_LABELS[col] ? t(COLUMN_LABELS[col]) : col;

// data 内字段的多语言（按小写 key 匹配，兼容大小写写法）
const DATA_FIELD_LABELS: Record<string, string> = {
  clientuniqueid: "fields.clientUniqueId",
  bankaccountname: "fields.bankAccountName",
  bankaccountnumber: "fields.bankAccountNumber",
  bsb: "fields.bsb",
  payid: "fields.payId",
};
const dataFieldLabel = (key: string) => {
  const mapped = DATA_FIELD_LABELS[String(key).toLowerCase()];
  return mapped ? t(mapped) : key;
};

const STATUS_LABELS: Record<number, string> = {
  [PaymentReceivableTransactionStatusTypes.Received]: "status.received",
  [PaymentReceivableTransactionStatusTypes.PaymentAndDepositCreated]:
    "status.paymentAndDepositCreated",
};
const statusLabel = (status: any) =>
  STATUS_LABELS[status] ? t(STATUS_LABELS[status]) : status;

// status 选项：value 为枚举数字，label 为多语言文本
const statusOptions = Object.keys(PaymentReceivableTransactionStatusTypes)
  .filter((k) => isNaN(Number(k)))
  .map((k) => {
    const value = (PaymentReceivableTransactionStatusTypes as any)[k];
    return { value, label: statusLabel(value) };
  });

const isDateColumn = (col: string) => /on$/i.test(col);

const formatCell = (value: any) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return value;
};

const formatDateTime = (value: any) => {
  if (!value) return "";
  const d = moment(value);
  return d.isValid() ? d.format("YYYY-MM-DD HH:mm:ss") : value;
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  // 组装请求参数：全部（null）不传，选了才传
  const params: any = { page: _page, size: criteria.value.size };
  if (filters.value.type) params.type = filters.value.type;
  if (filters.value.status != null) params.status = filters.value.status;
  try {
    const res = await svc.queryPaymentReceivableTransactions(params);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.error("Error fetching payment receivable transactions:", error);
    data.value = [];
    criteria.value = {
      ...criteria.value,
      total: 0,
      pageCount: 1,
      hasMore: false,
    };
  } finally {
    isLoading.value = false;
  }
};

const pageChange = (page: number) => {
  fetchData(page);
};

// 通过 paymentId 拉取充值详情并弹窗显示
const detailVisible = ref(false);
const detailLoading = ref(false);
const detail = ref<any>(null);

const actualAmount = (amount: any) => {
  if (amount === null || amount === undefined) return "";
  return new Decimal(amount)
    .div(100)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const currencyLabel = (currencyId: any) =>
  currencyId != null ? t(`type.currency.${currencyId}`) : "";

const formatExchangeRate = (item: any) => {
  const exchangeRate = item?.payment?.exchangeRate;
  const fromCurrency = currencyLabel(item?.currencyId);
  const toCurrency = currencyLabel(item?.payment?.currencyId);
  if (!fromCurrency || !toCurrency) return exchangeRate;
  return `${exchangeRate} ( ${fromCurrency}${toCurrency} )`;
};

const openPaymentDetail = async (paymentId: number) => {
  detail.value = null;
  detailVisible.value = true;
  detailLoading.value = true;
  try {
    const res = await svc.queryDeposits({ paymentId, page: 1, size: 1 });
    detail.value = res.data?.[0] ?? null;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    detailLoading.value = false;
  }
};

const confirmSearch = () => {
  fetchData(1);
};

const clearSearch = () => {
  filters.value = { type: null, status: null };
  fetchData(1);
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TableFooter = _resolveComponent("TableFooter")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_select, {
          modelValue: filters.value.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.type) = $event)),
          class: "w-200px",
          placeholder: _ctx.$t('fields.type'),
          clearable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              value: null,
              label: _ctx.$t('fields.all')
            }, null, 8, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeOptions), (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item,
                value: item,
                label: item
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_select, {
          modelValue: filters.value.status,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.status) = $event)),
          class: "w-200px",
          placeholder: _ctx.$t('fields.status'),
          clearable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              value: null,
              label: _ctx.$t('fields.all')
            }, null, 8, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusOptions), (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                value: item.value,
                label: item.label
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_button, {
          plain: "",
          type: "primary",
          onClick: confirmSearch
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          plain: "",
          type: "info",
          onClick: clearSearch
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                  return (_openBlock(), _createElementBlock("th", { key: col }, _toDisplayString(columnLabel(col)), 1))
                }), 128)),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (data.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                          return (_openBlock(), _createElementBlock("td", { key: col }, [
                            (col === 'data')
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.data || {}, (val, key) => {
                                  return (_openBlock(), _createElementBlock("div", { key: key }, [
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(dataFieldLabel(key)) + ":", 1),
                                    _createTextVNode(" " + _toDisplayString(formatCell(val)), 1)
                                  ]))
                                }), 128))
                              : (col === 'status')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(statusLabel(item[col])), 1)
                                  ], 64))
                                : (isDateColumn(col))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(_toDisplayString(formatDateTime(item[col])), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(_toDisplayString(formatCell(item[col])), 1)
                                    ], 64))
                          ]))
                        }), 128)),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            plain: "",
                            onClick: ($event: any) => (openPaymentDetail(item.paymentId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.viewDetails")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
          ])
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((detailVisible).value = $event)),
      title: _ctx.$t('fields.paymentDetail'),
      width: "520",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        (detailLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_LoadingRing)
            ]))
          : (detail.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("fields.paymentNo")), 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(detail.value.payment?.number), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("title.paymentMethod")), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(detail.value.payment?.paymentServiceName), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("fields.amount")), 1),
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_BalanceShow, {
                      "currency-id": detail.value.currencyId,
                      balance: detail.value.amount
                    }, null, 8, ["currency-id", "balance"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("fields.actualAmount")), 1),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(actualAmount(detail.value.payment?.amount)), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("fields.exchangeRate")), 1),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(formatExchangeRate(detail.value)), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("fields.tradeAccount")), 1),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(detail.value.targetTradeAccount?.accountNumber), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("fields.group")), 1),
                  _createElementVNode("span", _hoisted_35, _toDisplayString(detail.value.targetTradeAccount?.group), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createVNode(_component_NoDataBox)
              ]))
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})